<template>
  <div class="form-area">
    <div class="form-title">
      如因提交錯誤個人資料以致申請失敗，本會恕不負責，請小心填寫。</br>
      If the application is rejected due to the submission of inaccurate personal data, we will not be</br> responsible for the
      consequences.Please fill it out carefully.
    </div>

    <el-row :gutter="10" class="form-row" style="margin-top:0px">
      <el-col :span="4">
        <div class="form-label">電郵地址 *</br> Email</div>
      </el-col>
      <el-col :span="8">
        <div class="form-input">
          <el-input v-model="verifyEmail" placeholder="Ex: myname@example.com" @keyup.enter="nextSetp"></el-input>
        </div>
        <div class="form-tip-under">
          此電郵地址用於接收網上申請確認及申請編號等電郵</br>
          The email address will be used to receive the confirmation email for the online application and the application number.
        </div>
      </el-col>
      <el-col :span="12">
        <div class="form-tip-mid"><i class="el-icon-question" />當按下一步，電郵地址將<span
            style="color:red">不可修改</span>，請小心填寫。</br>Once you press 'Next
           Step,' the email <span style="color:red">cannot be modified</span>. Please fill it out
          carefully.
        </div>
      </el-col>
    </el-row>

    <div class="btn-box">
      <el-col :span="4"></el-col>
      <el-button class="next-btn" type="warning" round @click="nextSetp">下一步 Next</el-button>
    </div>

  </div>
</template>

<script>
  import {
    validateEmail
  } from "@/utils/json/utils";
  import {
    sendContinueVerifyMail
  } from "@/assets/js/api.js";
  export default {
    data() {
      return {
        verifyEmail: "", //836579123@qq.com 测试
        setepName: this.$store.getters.querySetepInfo.currentStepName,
      };
    },
    methods: {
      nextSetp() {
        if (!validateEmail(this.verifyEmail)) {
          this.$message.warning(
            "請輸入正確格式的電郵地址 Please Enter Correct format Email!"
          );
          return;
        }
        //先将邮箱号码缓存
        this.Session.set("verifyEmail", this.verifyEmail);
        if ("apply" === this.setepName) {
          //首次申请 下一步操作,跳转至一人/二人申请选择界面
          this.$store.dispatch("NEXT_STEP", {
            changeStep: false,
            operateName: "selectPage",
          });
        }
        if ("continue" === this.setepName) { //繼續填寫申請
          //调用验证接口，发送邮件
          sendContinueVerifyMail({
            verifyEmail: this.verifyEmail,
          }).then((res) => {
            this.$message.success("驗證碼經已發出，請查閱電子郵箱。");
            //跳转到邮箱验证界面
            this.$store.dispatch("NEXT_STEP", {
              changeStep: false,
              operateName: "emailVerify",
            });
          });
        }
      },
    },
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/apply/child/emailForm.vue